module.exports = __webpack_public_path__ + "media/react/lib/icons/assets/checkmarks-c1484fc242a61595eb75ca8c1fa381ff.png";